import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'localDateTime' })

export class LocalDateTimePipe implements PipeTransform {

    public transform(value: Date | undefined): string {

        let result: string = '';

        if (value) {

            const localDate = new Date(value);

            const formatter = new Intl.DateTimeFormat('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
                timeZoneName: 'short'
            });

            result = formatter.format(localDate).replace(',', '');
        }

        return result;
    }
}
